import { MutationTree } from 'vuex';
import { IAPIStoreState } from '@/types';

export const apiMutations: MutationTree<IAPIStoreState> = {};
